import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { WavyBackground } from "../ui/wavy-background.tsx";
import CarouselWrapper from "./Carouslwrapper.jsx";
import VideoMain from "./content/Valsco.mp4";
gsap.registerPlugin(ScrollTrigger);

const NewService = () => {
  const headingRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const heading = headingRef.current;
    const video = videoRef.current;

    // Heading reveal
    gsap.fromTo(
      heading,
      { y: 60, opacity: 0, scale: 0.98 },
      {
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.9,
        ease: "power3.out",
        delay: 0.15,
      }
    );

    // Video scroll-triggered reveal
    if (video) {
      gsap.fromTo(
        video,
        { opacity: 0, scale: 0.9 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.9,
          ease: "power3.out",
          scrollTrigger: {
            trigger: video,
            scroller: "body",
            start: "top 75%",
            end: "bottom 60%",
            scrub: false,
            toggleActions: "play none none reverse",
          },
        }
      );
    }
  }, []);

  // SVG pattern for text background
  const svgText = `<svg xmlns='http://www.w3.org/2000/svg' width='240' height='40'>
    <text x='0' y='30' font-family='Poppins, Arial, sans-serif' font-size='20' fill='white' opacity='0.88'>
      click the card &#160; click the card &#160; click the card &#160; click the card
    </text>
  </svg>`;

  const dataUri = `url("data:image/svg+xml;utf8,${encodeURIComponent(svgText)}")`;

  return (
    <div className="bg-black text-white overflow-x-hidden">
      {/* Wavy Hero Section */}
      <WavyBackground className="pb-10 pt-10 flex flex-col items-center justify-center">
        <h1
          className="text-center text-white font-semibold"
          style={{
            fontSize: "clamp(4rem, 20vw, 14rem)", // ✅ responsive font size
            margin: 0,
            padding: 0,
            opacity: 0.95,
            lineHeight: 1,
          }}
        >
          WELCOME
        </h1>
      </WavyBackground>

      {/* Video Section */}
      <div id="page2" className="flex w-full justify-center items-center py-8">
        <div id="video" ref={videoRef} className="w-full flex justify-center">
          <video
            src={VideoMain}
            muted
            playsInline
            controls
            className="lg:w-[95%] w-[92%] rounded-[20px] shadow-lg"
          />
        </div>
      </div>

      {/* Big Pattern Heading + Carousel */}
      <section className="w-full flex flex-col items-center px-4 md:px-8 lg:px-16">
        <div
          ref={headingRef}
          className="w-full max-w-[1400px] flex flex-col items-center"
        >
          <h2
            aria-label="Need a Service"
            className="big-pattern-heading font-extrabold text-center"
            style={{
              fontSize: "clamp(6rem, 18vw, 22rem)",
              lineHeight: 0.85,
              margin: 0,
              padding: 0,
              WebkitTextStroke: "1px #fff",
              backgroundImage: dataUri,
              backgroundRepeat: "repeat",
              backgroundSize: "240px 40px",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              zIndex: 20,
              textTransform: "uppercase",
              letterSpacing: "-0.02em",
            }}
          >
            NEED A SERVICE?
          </h2>

          <p
            className="mt-6 text-center text-sm md:text-base lg:text-lg"
            style={{ color: "rgba(255,255,255,0.9)", maxWidth: 900 }}
          >
            Click the card to choose the service you want.
          </p>
        </div>

        {/* Responsive Carousel Section */}
<div className="w-full flex justify-center mt-10 mb-20 px-2 sm:px-4 md:px-6 lg:px-10">
  <div
    className="w-full max-w-[1400px] flex justify-center items-center"
    style={{
      overflow: "hidden",         // prevents unwanted scrollbars
      borderRadius: "20px",       // keeps rounded edges consistent
      padding: "0 10px",          // small inner padding for mobile
    }}
  >
    <CarouselWrapper />
  </div>
</div>

      </section>

      {/* Background Motion for Heading */}
      <style>{`
        .big-pattern-heading {
          animation: movePattern 12s linear infinite;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        @keyframes movePattern {
          0% { background-position: 0 0; }
          100% { background-position: -240px 0; }
        }
        @media (max-width: 420px) {
          .big-pattern-heading {
            font-size: clamp(3rem, 22vw, 9rem) !important;
            WebkitTextStroke: 0.7px;
          }
        }
      `}</style>
    </div>
  );
};

export default NewService;
